import angular from 'angular';
import { PaymentTemplateService } from './PaymentTemplateService';
import { PaymentSegmentService } from './PaymentSegmentService';
export const paymentServicesModule = angular
    .module('paymentServicesModule', [])
    .service('PaymentTemplateService', PaymentTemplateService)
    .service('PaymentSegmentService', PaymentSegmentService)
    .name;
